// NOTE: Code assumes you already have working routing and `/admin/company/:id` page.

import React, { useEffect, useState } from 'react';
import axiosInstance from '../../utils/axiosInstance';
import { Form, Input, message, Modal, Table, Tooltip } from 'antd';
import CustomSearch from '../../components/search/CustomSearch';
import {
    LoadingOutlined,
} from "@ant-design/icons";
import { Link } from 'react-router-dom';
import RightArrowIcon from '../../components/icons/RightArrowIcon';

const { TextArea } = Input;

const ProfessionalCompanies = () => {
    const [professionals, setProfessionals] = useState([]);
    const [deactivateModal, setDeactivateModal] = useState(false);
    const [companyId, setCompanyId] = useState(null);
    const [modalText, setModalText] = useState("");
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [activeOpen, setActiveOpen] = useState(false);

    const fetchCompanies = async () => {
        try {
            setLoading(true);
            const res = await axiosInstance.get('/professional-companies/');
            setProfessionals(res.data.data);
            setLoading(false);
        } catch (err) {
            setLoading(false);
            message.error("Failed to fetch data");
        }
    };

    const handleCancel = () => {
        setDeactivateModal(false);
        setActiveOpen(false);
        form.resetFields();
    };

    const formatIndianDate = (dateString) => {
        return new Date(dateString).toLocaleDateString("en-IN", {
            year: "numeric",
            month: "short",
            day: "numeric",
        });
    };

    const showDeactivateModal = (id) => {
        setCompanyId(id);
        setModalText("Are you sure you want to deactivate this company?");
        setDeactivateModal(true);
    };

    const showActivateModal = (id) => {
        setCompanyId(id);
        setModalText("Are you sure you want to activate this company?");
        setActiveOpen(true);
    };

    const handleCompanyStatus = (action) => {
        const payload = {
            active: action === 'activate',
            ...(action === 'deactivate' && { reason: form.getFieldValue('reason') })
        };

        axiosInstance.put(`/company/${companyId}/active/`, payload)
            .then(() => {
                message.success(`Company ${action}d successfully`);
                setDeactivateModal(false);
                setActiveOpen(false);
                form.resetFields();
                fetchCompanies();
            })
            .catch(() => message.error("Something went wrong"));
    };

    const expandedRowRender = (record) => {
        const createdCompanies = record.created_companies || [];

        if (!createdCompanies.length) {
            return <p className="text-[12px] italic text-gray-500">No created companies.</p>;
        }

        const columns = [
            { title: 'Name', dataIndex: 'name' },
            { title: 'Admin Email', dataIndex: 'admin_email' },
            { title: 'Admin Contact', dataIndex: 'admin_contact_number' },
            { title: 'Valid From', dataIndex: 'valid_from', render: formatIndianDate },
            { title: 'Valid To', dataIndex: 'valid_to', render: formatIndianDate },
            // {
            //     title: 'Status',
            //     dataIndex: 'is_active',
            //     render: (val) => val ? 'Active' : 'Inactive'
            // },
            {
                title: 'Status',
                dataIndex: 'id',
                render: (id, row) => (
                    row.is_active ? (
                        <div className='inline-block rounded-full border-2 border-red px-6 pb-[6px] pt-2 bg-red-400 text-[10px] font-medium uppercase leading-normal text-black transition duration-150 ease-in-out hover:border-danger-600 hover:bg-neutral-500 hover:bg-opacity-10 hover:text-danger-600 focus:border-danger-600 focus:text-danger-600 focus:outline-none focus:ring-0 active:border-danger-700 active:text-danger-700 dark:hover:bg-neutral-100 dark:hover:bg-opacity-10'
                            onClick={() => showDeactivateModal(id)}>Deactivate</div>
                    ) : (
                        <div className="inline-block rounded-full border-2 border-success px-6 pb-[6px] pt-2 bg-green-500 text-[10px] font-medium uppercase leading-normal text-black transition duration-150 ease-in-out hover:border-success-600 hover:bg-neutral-500 hover:bg-opacity-10 hover:text-success-600 focus:border-success-600 focus:text-black focus:outline-none focus:ring-0 active:border-success-700 active:text-black-700 dark:hover:bg-neutral-100 dark:hover:bg-opacity-10"
                            onClick={() => showActivateModal(id)}>Activate</div>
                    )
                )
            },
            {
                title: 'View',
                dataIndex: 'id',
                render: (id) => (
                    <Link to={`/admin/company/${id}`}><RightArrowIcon /></Link>
                )
            },
        ];

        return <Table columns={columns} size='small' className='cursor-pointer' dataSource={createdCompanies} rowKey="id" pagination={false} />;
    };

    const columns = [
        {
            title: 'Professional Name',
            dataIndex: 'professional_name',
        },
        {
            title: 'Professional Email',
            dataIndex: 'professional_email',
        },
        {
            title: 'Own Company',
            dataIndex: ['own_company', 'name'],
        },
        {
            title: 'Contact No.',
            dataIndex: ['own_company', 'admin_contact_number'],
        },
        {
            title: "Change Status",
            dataIndex: "is_active",
            key: "is_active",
            render: (text, record) => (
                <>
                    {record.is_active ? (
                        <div
                            // onClick={() => showADeactivateeModal(record.id)}
                            type="submit"
                            className="inline-block rounded-full border-2 border-red px-6 pb-[6px] pt-2 bg-red-400 text-[10px] font-medium uppercase leading-normal text-black transition duration-150 ease-in-out hover:border-danger-600 hover:bg-neutral-500 hover:bg-opacity-10 hover:text-danger-600 focus:border-danger-600 focus:text-danger-600 focus:outline-none focus:ring-0 active:border-danger-700 active:text-danger-700 dark:hover:bg-neutral-100 dark:hover:bg-opacity-10"
                        >
                            Deactivate
                        </div>
                    ) : (
                        <div
                            // onClick={() => showCompanyActiveModal(record.id)}
                            className="inline-block rounded-full border-2 border-success px-6 pb-[6px] pt-2 bg-green-500 text-[10px] font-medium uppercase leading-normal text-black transition duration-150 ease-in-out hover:border-success-600 hover:bg-neutral-500 hover:bg-opacity-10 hover:text-success-600 focus:border-success-600 focus:text-black focus:outline-none focus:ring-0 active:border-success-700 active:text-black-700 dark:hover:bg-neutral-100 dark:hover:bg-opacity-10"
                        >
                            Activate
                        </div>
                    )}
                </>
            ),
        },
        {
            title: 'View',
            dataIndex: ['own_company', 'id'],
            render: (id) => (
                <Link to={`/admin/company/${id}`}><RightArrowIcon /></Link>
            )
        },
    ];

    useEffect(() => {
        fetchCompanies();
    }, []);

    return (
        <div>
            <div className="flex justify-between items-center mb-4">
                <div className='w-1/2 flex gap-4'>
                    <h1 className="text-[15px] pt-1 font-bold w-3/4">Professional Companies</h1>
                    <CustomSearch onSearch={(val) => fetchCompanies(val)} />

                </div>
            </div>
            {loading ? (
                <div className="text-center py-10">
                    <LoadingOutlined style={{ fontSize: 40 }} />
                </div>
            ) : (
                <Table
                    dataSource={professionals}
                    columns={columns}
                    expandable={{ expandedRowRender }}
                    rowKey="professional_id"
                    size='small'
                />
            )}

            <Modal
                title="Deactivate Company"
                open={deactivateModal}
                onOk={() => form.submit()}
                onCancel={handleCancel}
                okText="Deactivate"
            >
                <Form form={form} onFinish={() => handleCompanyStatus("deactivate")}>
                    <Form.Item name="reason" label="Reason" rules={[{ required: true }]}>
                        <TextArea rows={3} />
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                title="Activate Company"
                open={activeOpen}
                onOk={() => handleCompanyStatus("activate")}
                onCancel={handleCancel}
                okText="Activate"
            >
                <p>{modalText}</p>
            </Modal>
        </div>
    );
};

export default ProfessionalCompanies;